import React from 'react';
import { motion } from 'framer-motion';
export function TestimonialsBanner() {
  return <section className="w-full bg-brand-bg pt-6 md:pt-8 pb-12 md:pb-16 px-6 overflow-hidden" data-id="element-222">
      <motion.div className="max-w-5xl mx-auto text-center relative" initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} data-id="element-223">
        {/* Ambient glow behind the green text */}
        <div className="absolute left-1/2 -translate-x-1/2 bottom-[15%] w-[300px] md:w-[500px] h-[40px] bg-amber-500/30 blur-[60px] rounded-full pointer-events-none" data-id="element-224" />

        <h2 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white leading-tight relative z-10" data-id="element-225">
          Más Testimonios de
          <br data-id="element-226" />
          los resultados de
          <br data-id="element-227" />
          <span className="text-brand-green" data-id="element-228">EMPRENDE DIGITAL</span>
        </h2>
        <p className="text-lg md:text-2xl text-white/70 mt-4 relative z-10" data-id="element-229">
          Lo que pasa cuando aplican esta guía 👇
        </p>
      </motion.div>
    </section>;
}